import React, { useContext, useEffect, useState } from "react";
import "./App.css";
import About from "./partials/About";
import Card from "./partials/Card";
import Footer from "./partials/Footer";
import Projects from "./partials/Projects";
import Skills from "./partials/Skills";
import AOS from "aos";
import "aos/dist/aos.css";
import dataFr from "./assets/data_fr";
import dataEn from "./assets/data_en";
import { LanguageContext } from "./context/LanguageContext";
import Modal from "./partials/components/Modal";
import ScrollToTopButton from "./partials/components/ScrollToTopButton";

function App() {
  const { language } = useContext(LanguageContext);
  const data = language === "fr" ? dataFr : dataEn;

  const [activeModal, setActiveModal] = useState(null);

  const openModal = (type) => setActiveModal(type);
  const closeModal = () => setActiveModal(null);

  useEffect(() => {
    AOS.init({
      once: true,
    });
  });

  useEffect(() => {
    document.title = `${data.name} - ${data.document_title}`;
  }, [language]);

  return (
    <div className="min-h-screen py-10 px-3 sm:px-5 bg-gray-100">
      <div data-aos="fade-down" data-aos-duration="800">
        <Card
          name={data.name}
          title={data.title}
          social={data.social}
          onOpenCertificate={() => openModal("certificate")}
          onOpenCV={() => openModal("cv")}
        />
      </div>
      <div data-aos="fade-up" data-aos-duration="800" data-aos-delay="400">
        <About title={data.about.title} description={data.about.description} />
        <Skills skills={data.skills} />
        <Projects projects={data.projects} />
        <Footer github={data.social.github} />
      </div>
      <Modal isOpen={!!activeModal} onClose={closeModal}>
        {activeModal === "certificate" && (
          <img
            src="/certificate-florent_cussatlegras.png"
            alt="Symfony Certification"
            className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-2xl"
          />
        )}

        {activeModal === "cv" && (
          <iframe
            src={
              language === "fr"
                ? "/Florent_Cussatlegras_CV_fr.pdf"
                : "/Florent_Cussatlegras_CV_en.pdf"
            }
            title="Resume"
            className="w-[90vw] h-[90vh] rounded-lg shadow-2xl"
          />
        )}
      </Modal>
      <ScrollToTopButton />
    </div>
  );
}
export default App;
